import React from 'react';
import styled from 'styled-components';
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import { device } from '../utils/Brekapoints';

const MainStyles = styled.main`
  display: block;
  width: 100%;
  margin: 0 auto;

  @media ${device.mobile} {
    padding: 0 14px;
  }
`;

export default function LayoutFullPage({ children }) {
  return (
    <>
      <GlobalStyles />
      <Typography />
      <MainStyles>{children}</MainStyles>
    </>
  );
}
